import * as Yup from "yup";
import { shouldShowAddressState, validatePostalCode } from "services";

export const agentSchema = [
  // Stage 0: Company Information
  Yup.object({
    agentName: Yup.string().required("Company name is required"),
    agentEmail: Yup.array().of(Yup.string().email("Invalid email format")),
    description: Yup.string().required("Description is required"),
    agentUrl: Yup.string(),
    contact: Yup.array().of(
      Yup.object({
        countryCode: Yup.string().test(
          "contact-conditional",
          "Country code is required",
          function (value) {
            const { countryCode, areaCode, number, extension } = this.parent;
            const hasAnyValue = [countryCode, areaCode, number, extension].some(
              (val) => val && val !== "",
            );
            return hasAnyValue ? !!(value && value.trim()) : true;
          },
        ),
        areaCode: Yup.string().nullable(),
        number: Yup.string().test(
          "contact-conditional",
          "Phone number is required",
          function (value) {
            const { countryCode, areaCode, number, extension } = this.parent;
            const hasAnyValue = [countryCode, areaCode, number, extension].some(
              (val) => val && val !== "",
            );
            return hasAnyValue ? !!(value && value.trim()) : true;
          },
        ),
        extension: Yup.string().nullable(),
      }),
    ),
    address: Yup.array().of(
      Yup.object({
        street1: Yup.string().test(
          "address-conditional",
          "Please enter street address",
          function (value) {
            const { street2, city, state, postalCode, country } = this.parent;
            const hasAnyValue = [
              street2,
              city,
              state,
              postalCode,
              country,
            ].some((val) => val && val !== "");
            return hasAnyValue ? !!(value && value.trim()) : true;
          },
        ),
        city: Yup.string().test(
          "address-conditional",
          "City is required",
          function (value) {
            const { street1, street2, state, postalCode, country } =
              this.parent;
            const hasAnyValue = [
              street1,
              street2,
              state,
              postalCode,
              country,
            ].some((val) => val && val !== "");
            return hasAnyValue ? !!(value && value.trim()) : true;
          },
        ),
        state: Yup.string().test(
          "state-conditional-required",
          "State/Province is required.",
          function (value) {
            const { street1, street2, city, postalCode, country } = this.parent;

            const hasAnyValue = [
              street1,
              street2,
              city,
              postalCode,
              country,
            ].some((val) => val && val !== "");

            if (!hasAnyValue) return true;

            if (country) {
              try {
                const stateRequired = shouldShowAddressState(country);
                if (!stateRequired) return true;
              } catch {}
            }

            return !!(value && value.trim());
          },
        ),
        postalCode: Yup.string().test(
          "postal-conditional",
          "Postal code is required or invalid",
          function (value) {
            const { street1, street2, city, state, country } = this.parent;

            const hasAnyValue = [street1, street2, city, state, country].some(
              (val) => val && val !== "",
            );

            if (!hasAnyValue) return true;

            if (!value || !value.trim()) return false;

            if (country) {
              try {
                return validatePostalCode(value, country);
              } catch {
                return !!value.trim();
              }
            }

            return true;
          },
        ),
        country: Yup.string().test(
          "address-conditional",
          "Country is required",
          function (value) {
            const { street1, street2, city, state, postalCode } = this.parent;
            const hasAnyValue = [
              street1,
              street2,
              city,
              state,
              postalCode,
            ].some((val) => val && val !== "");
            return hasAnyValue ? !!(value && value.trim()) : true;
          },
        ),
      }),
    ),
  }),

  // Stage 1: Review
  Yup.object({}),
];
